import React, { useState, useEffect } from 'react';
import CasinoCard from './CasinoCard';
import { fetchCasinos } from '../services/api';
import star from '../assets/images/star.svg';

function CasinoList() {
  const [casinos, setCasinos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadCasinos = async () => {
      try {
        setLoading(true);
        setError(null);
        const data = await fetchCasinos();
        setCasinos(data);
      } catch (err) {
        console.error('Failed to load casinos:', err);
        setError('Failed to load casinos. Please try again later.');
      } finally {
        setLoading(false);
      }
    };

    loadCasinos();
  }, []);

  if (loading) {
    return (
      <section className="cardBoxes text-white mb-0 pb-30">
        <div className="container">
          <div className="text-center" style={{ padding: '50px 0' }}>
            <p className="f-white f-22">Loading casinos...</p>
          </div>
        </div>
      </section>
    );
  }

  if (error) {
    return (
      <section className="cardBoxes text-white mb-0 pb-30">
        <div className="container">
          <div className="text-center" style={{ padding: '50px 0' }}>
            <p className="f-white f-22" style={{ color: '#ff5a5f' }}>{error}</p>
          </div>
        </div>
      </section>
    );
  }

  if (casinos.length === 0) {
    return (
      <section className="cardBoxes text-white mb-0 pb-30">
        <div className="container">
          <div className="text-center" style={{ padding: '50px 0' }}>
            <p className="f-white f-22">No casinos found.</p>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className="cardBoxes text-white mb-0 pb-30">
      <div className="container">
        {casinos.map((casino) => (
          <CasinoCard 
            key={casino.id} 
            casino={{
              ...casino,
              starImage: casino.starImage || star
            }} 
          />
        ))}
      </div>
    </section>
  );
}

export default CasinoList;
